import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../hooks/useAuth";
import { SuccessModal } from "../components/SuccessModal";
import { continuarConPlanPendiente } from "../lib/planPendiente";

type Status = "loading" | "success" | "error";

export default function Verificar() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { saveSession } = useAuth();

  const token = searchParams.get("token") ?? "";

  const [status, setStatus]   = useState<Status>("loading");
  const [error, setError]     = useState<string>("");
  const [email, setEmail]     = useState("");
  const [resending, setResending] = useState(false);
  const [resendMsg, setResendMsg] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setError("Este link no es válido o ya fue usado.");
      return;
    }
    api.verificarEmail(token).then(async (r) => {
      if (r.ok) {
        saveSession(r.data.token, r.data.user);
        const fueAStripe = await continuarConPlanPendiente(r.data.token);
        if (!fueAStripe) setStatus("success");
      } else {
        setStatus("error");
        setError(r.error.message || "Este link ya no es válido o expiró.");
        if (r.error.email) setEmail(r.error.email);
      }
    });
  }, [token]);

  async function handleResend() {
    if (!email.trim()) return;
    setResending(true);
    setResendMsg(null);
    const r = await api.reenviarVerificacion(email.trim());
    setResending(false);
    setResendMsg(r.ok ? r.data.message : r.error.message);
  }

  if (status === "loading") {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)" }}>
        <span className="spinner spinner--dark" />
      </div>
    );
  }

  if (status === "success") {
    return (
      <SuccessModal
        emoji="🎉"
        title="¡Tu cuenta está verificada!"
        message="Bienvenido/a a PzicoDosis. Ya puedes acceder a tu espacio, tu biblioteca y la comunidad."
        actionLabel="Ir a mi espacio →"
        onAction={() => navigate("/dashboard")}
      />
    );
  }

  return (
    <div style={{
      minHeight: "100vh", display: "grid", placeItems: "center", background: "var(--bg)",
      fontFamily: "var(--font-body)", padding: 24,
    }}>
      <div className="card" style={{ maxWidth: 420, width: "100%", padding: 36, textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 14 }}>⚠️</div>
        <h1 style={{ fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 22, margin: "0 0 10px" }}>
          Este link ya no es válido
        </h1>
        <p style={{ fontSize: 14.5, color: "var(--muted)", lineHeight: 1.6, margin: "0 0 24px" }}>
          {error}
        </p>

        <label className="field-label" style={{ textAlign: "left" }}>Tu correo electrónico</label>
        <input
          type="email" className="form-input" placeholder="tu@correo.com"
          value={email} onChange={(e) => setEmail(e.target.value)}
          style={{ marginBottom: 14 }}
        />
        <button onClick={handleResend} disabled={resending || !email.trim()} className="btn btn-primary btn--full">
          {resending ? <><span className="spinner" /> Enviando…</> : "Reenviar email de verificación"}
        </button>

        {resendMsg && (
          <p style={{ fontSize: 13.5, color: "var(--copper)", marginTop: 14 }}>{resendMsg}</p>
        )}

        <Link to="/login" style={{ display: "block", marginTop: 20, fontSize: 13.5, color: "var(--muted-2)" }}>
          Volver a iniciar sesión
        </Link>
      </div>
    </div>
  );
}
